/* card/sagas*/
import {
    select,
    all,
    fork,
    put,
    takeEvery,
    takeLatest,
    spawn,
  } from "redux-saga/effects";
  import { has, isNil, includes, isEmpty } from "ramda";
  import { CardTypeCodec, CardTypeActionTypes } from "./types";
  import { fetch,save } from "../../repo/cardType";
  import {
    fetchRequest,
    fetchError,
    fetchSuccess,
    saveRequest,
    saveSuccess,
    saveError,
  } from "./actions";
  import { dirty } from "../session/actions";
  import { Error, isAuthError } from "../";
  
  function* handleFetch(action: ReturnType<typeof fetchRequest>) {
    try {
      const user = yield fetch(action.payload.id, action.payload.params);
      if (user.errors && !isEmpty(user.errors)) {
        if (isAuthError(user.errors)) {
          yield put(dirty());
        }
        yield put(fetchError(JSON.stringify(user.errors)));
      } else {
        yield put(fetchSuccess(user));
      }
    } catch (err) {
      yield put(fetchError(err));
    }
  }
  
  function* watchFetchRequest() {
    yield takeEvery(CardTypeActionTypes.FETCH, handleFetch);
  }
  
  function* handleSave(action: ReturnType<typeof saveRequest>) {
    try {
      const user = yield save(action.payload.data);
      // we may still have an error
      // if so then we should yield error
      if (user.errors && !isEmpty(user.errors)) {
        if (isAuthError(user.errors)) {
          yield put(dirty());
        }
        yield put(saveError(JSON.stringify(user.errors)));
        action.payload.callback &&
          action.payload.callback(JSON.stringify(user.errors), null);
      } else {
        yield put(saveSuccess(user));
        action.payload.callback && action.payload.callback(null, user);
      }
    } catch (err) {
      yield put(saveError(err));
      action.payload.callback &&
        action.payload.callback("An error occurred while saving Card", null);
    }
  }
  
  function* watchSaveRequest() {
    yield takeEvery(CardTypeActionTypes.SAVE_REQUEST, handleSave);
  }
  
  export default function* cardTypeSaga() {
    yield all([
      spawn(watchFetchRequest),
      spawn(watchSaveRequest),
    ]);
  }